import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import fetchPoints from '../reducers/fetchSpacesPoints';

export const useFetchSpacesPoints = () => {
	const dispatch = useDispatch();

	const fetchSpacesPoints = useCallback(
		async (params) => {
			return dispatch(fetchPoints.action(params));
		},
		[dispatch],
	);

	return {
		fetchSpacesPoints,
	};
};
